

















































































/* eslint-disable @typescript-eslint/no-non-null-assertion */
import Vue from 'vue'
import { mapState, mapGetters } from 'vuex'
import { AgreementState as State } from '@/store/modules/agreement'
import AgreementHokkokubank from '@/components/atoms/AgreementHokkokubank.vue'
import AgreementOkasan from '@/components/atoms/AgreementOkasan.vue'
import AgreementHamamatsuIwata from '@/components/atoms/AgreementHamamatsuIwata.vue'
import AgreementChukyo from '@/components/atoms/AgreementChukyo.vue'
import AgreementTaiko from '@/components/atoms/AgreementTaiko.vue'
import AgreementTohobank from '@/components/atoms/AgreementTohobank.vue'

type Data = {
  companyCode: string;
};

export default Vue.extend({
  name: 'AgreementOther',
  components: {
    'agreement-hokkokubank': AgreementHokkokubank,
    'agreement-okasan': AgreementOkasan,
    'agreement-hamamatsu-iwata': AgreementHamamatsuIwata,
    'agreement-chukyo': AgreementChukyo,
    'agreement-taiko': AgreementTaiko,
    'agreement-tohobank': AgreementTohobank
  },
  data (): Data {
    return {
      companyCode: process.env.VUE_APP_COMPANY_CODE
    }
  },
  computed: {
    ...mapGetters('agreement', ['canApply']),
    ...mapState('agreement', [
      'specificAccountCodes',
      'other'
    ]),
    ...mapState(['serviceName']),
    confirm: { // setterが必要
      get: function () {
        return (this.$store.state.agreement as State).confirm.other
      },
      set: () => { /* do nothing */ }
    },
    confirmSpecific: {
      get: function () {
        return (this.$store.state.agreement as State).other.confirmSpecific
      },
      set: () => { /* do nothing */ }
    }
  },
  created () {
    this.$store.dispatch('agreement/getSpecificAccountCodes')
  },
  mounted () {
    // 口座区分選択肢取得済みの場合は、スクロール制御しない
    // （chromeでは制御しなくても毎回スクロール位置は画面TOPになる）
    if (this.specificAccountCodes) {
      return
    }
    setTimeout(() => window.scrollTo(0, 0), 1)
  },
  beforeRouteLeave (to, from, next) {
    // 規約等の同意画面から離れる時は、moduleの値をクリアする
    if ((to.name as string).indexOf('agreement') !== 0) {
      this.$store.commit('agreement/resetConfirm')
    }
    next()
  },
  methods: {
    /**
     * 私は、規約などを確認し同意のうえ、上記の情報が正しいこと、および本人による手続きであることを誓約し、口座開設を申し込みます。
     */
    checkConfirm (value: boolean): void {
      this.$store.commit('agreement/confirm', { key: 'other', value })
    },
    updateForm (value: string, key: string): void {
      this.$store.commit('agreement/updateFormValue', { value, key })
      if (key === 'specificAccountCode' && this.other.confirmSpecific && value !== this.specificAccountCodes.SPECIFIC_WITHHOLDING.value) {
        // 特定口座あり以外に変えた場合
        this.$store.commit('agreement/updateFormValue', { key: 'confirmSpecific', value: false })
      }
    },
    goBack (): void {
      this.$router.push({ name: 'agreementPreContract' })
    },
    apply (): void {
      if (this.canApply) {
        this.$store.dispatch('agreement/apply').then(() => {
          this.$router.push({ name: 'complete' })
        })
      }
    }
  }
})
